import React from "react";
import "./Filler.css";

const Filler = function() {
  return (
    <div className="filler text-center row">
      <div className="col-12">
        <h1>Om Corviva</h1>
      </div>
      <div className="col-12 col-md-10 col-lg-8 col-xl-5 mx-auto">
        <p>
        Corviva har i nära samarbete med sina kunder utvecklat en plattform
         och ett heltäckande koncept för företag och organisationer som arbetar med
          frågor inom hälsa och arbetsmiljö. Vi sätter stort värde i att ha en nära
           kundrelation, för det är i den dagliga kontakten med våra kunder som
            behov framkommer och de bästa idéerna föds.
        </p>
      </div>
    </div>
  );
};

export default Filler;



// WEBPACK FOOTER //
// ./src/routes/StartPage/components/Filler/Filler.jsx